/**
 * Görev odaklı arayüzün metinleri (ADR 0027): "İşlerim" menü bölümleri, hızlı işlemler, ana sayfa, "Yeni kayıt" menüsü.
 * Hızlı işlem açıklamaları kullanıcının diliyle yazılır: düğmenin NE işe yaradığını tek cümlede söyler.
 */
export const trWork = {
  sections: {
    daily: "Günlük",
    reports: "Raporlar",
    operations: "İşletme",
    finance: "Finans",
    organization: "Kuruluş",
    upkeep: "Bakım ve uyum",
    costsUpkeep: "Gider ve bakım",
    shift: "Vardiya ve kasa",
    fuel: "Akaryakıt",
    market: "Market",
    services: "Yıkama ve şarj",
    wash: "Yıkama",
    invoicing: "Fatura",
    accounts: "Cari ve finans",
    ledger: "Muhasebe",
    spending: "Gider ve ödeme",
    tax: "Vergi ve fatura",
    records: "Kayıtlar",
    work: "İşlemlerim",
  },
  actions: {
    shiftOpen: { title: "Vardiya aç", description: "Vardiyayı başlatın, personeli ve tabancaları atayın." },
    myShift: { title: "Vardiyamı kapat", description: "Tahsilatınızı girip vardiyanızı teslim edin." },
    dayEnd: {
      title: "Günü kapat",
      description: "Z raporu, mutabakat ve kasa kontrolüyle iş gününü kilitleyin.",
    },
    zReport: { title: "Z raporu gir", description: "Yazar kasanın gün sonu raporunu kaydedin." },
    cashCount: { title: "Kasa sayımı", description: "Kasadaki nakdi sayıp kaydedin." },
    tankReading: { title: "Tank okuması gir", description: "Tanktaki yakıt seviyesini elle kaydedin." },
    totalizerReading: { title: "Endeks okuması gir", description: "Tabanca sayaçlarını okuyup kaydedin." },
    fuelDelivery: {
      title: "Tanker dolumu kaydet",
      description: "Gelen yakıtı irsaliyesiyle birlikte girin.",
    },
    fuelOrder: { title: "Akaryakıt siparişi ver", description: "Dağıtıcıya yakıt siparişi oluşturun." },
    priceChange: { title: "Fiyat değiştir", description: "Pompa ve kasa fiyatlarını güncelleyin." },
    goodsReceipt: { title: "Mal kabul", description: "Tedarikçiden gelen market ürünlerini stoğa alın." },
    stockCount: { title: "Sayım başlat", description: "Market stoğunu sayıp farkları kaydedin." },
    washStart: { title: "Yıkama başlat", description: "Üniteleri izleyin, yıkamayı başlatın." },
    washWorkOrders: { title: "El yıkama işleri", description: "Gelen aracı kaydedin, işi takip edin." },
    washAppointments: { title: "Randevular", description: "Günün yıkama randevularını görün." },
    evStart: { title: "Şarj başlat", description: "Şarj ünitelerini izleyin, oturum başlatın." },
    expense: { title: "Gider gir", description: "Faturalı ya da fişli bir harcamayı kaydedin." },
    workOrder: { title: "Arıza bildir", description: "Bozulan ekipman için bakım iş emri açın." },
    incomingInvoices: {
      title: "Gelen faturalar",
      description: "Tedarikçi e-faturalarını kontrol edip deftere alın.",
    },
    salesInvoice: {
      title: "Satış faturası kes",
      description: "Müşteriye e-Fatura ya da e-Arşiv düzenleyin.",
    },
    counterpartyTxn: {
      title: "Tahsilat / ödeme gir",
      description: "Cari hesaba tahsilat, ödeme ya da borç kaydedin.",
    },
    treasuryTxn: {
      title: "Kasa / banka hareketi",
      description: "Para giriş-çıkışını ya da virmanı kaydedin.",
    },
    instrumentBatch: {
      title: "Çek / senet bordrosu",
      description: "Alınan ya da verilen çek ve senetleri bordroyla girin.",
    },
    journalEntry: { title: "Muhasebe fişi gir", description: "Elle yevmiye fişi düzenleyin." },
    paymentPlan: { title: "Ödeme planla", description: "Vadesi gelen borçları ödeme partisine alın." },
    approvals: {
      title: "Onay bekleyenler",
      description: "Kararınızı bekleyen talepleri onaylayın ya da reddedin.",
    },
    userInvite: { title: "Kullanıcı davet et", description: "Ekibe yeni bir kişi ekleyin, rolünü seçin." },
    reports: { title: "Rapor al", description: "Satış, stok ve finans raporlarını açın." },
    stationComparison: {
      title: "İstasyonları karşılaştır",
      description: "Ciro, hacim ve fireyi istasyon istasyon görün.",
    },
    accountingReports: { title: "Mizan ve muavin", description: "Muhasebe raporlarını alın, dışa aktarın." },
    taxCalendar: { title: "Vergi takvimi", description: "Yaklaşan beyan ve ödeme tarihlerini görün." },
    invoicesView: { title: "Faturalar", description: "Kesilen ve gelen faturaları inceleyin." },
  },
  home: {
    greeting: {
      morning: "Günaydın, {{name}}",
      afternoon: "İyi günler, {{name}}",
      evening: "İyi akşamlar, {{name}}",
    },
    actionsTitle: "Ne yapmak istiyorsunuz?",
    actionsMore: "Diğer kayıtlar için üstteki “Yeni kayıt” düğmesini kullanın.",
    tasksTitle: "Bekleyen işler",
    tasksAllClear: "Bekleyen işiniz yok. Her şey yolunda.",
    tasksLabel: "Bekleyen işler listesi",
    tasks: {
      approvals: { title: "{{count}} talep kararınızı bekliyor", action: "Onayla" },
      days: {
        title: "{{count}} iş günü kapanmadı",
        titleAtLeast: "En az {{count}} iş günü kapanmadı",
        detail: "En eskisi: {{station}} · {{date}}",
        action: "Günü kapat",
      },
      tanks: {
        title: "{{count}} tank azalıyor",
        action: "Sipariş ver",
        actionView: "Tanklara bak",
      },
      alarms: {
        title: "{{count}} açık alarm",
        detail: "{{critical}} kritik · {{important}} önemli",
        action: "Alarmlara git",
      },
      agents: { title: "{{count}} istasyonun bağlantısı kopuk", action: "Ajanlara bak" },
      workOrders: { title: "{{count}} iş emrinin süresi aşıldı", action: "İş emirleri" },
      documents: { title: "{{count}} belgenin süresi doldu ya da doluyor", action: "Belgeler" },
    },
  },
  sidebar: {
    search: "Menüde sayfa bul",
    searchPlaceholder: "Sayfa bul…",
    noResults: "Eşleşen sayfa yok",
    results: "{{count}} sayfa",
    mine: "İşlerim",
    all: "Tüm modüller",
    allHint: "Yetkiniz olan diğer sayfalar",
  },
  newMenu: {
    button: "Yeni kayıt",
    title: "Ne kaydetmek istiyorsunuz?",
  },
};
